import { Paper, Stack, Typography } from "@mui/material";
import LogoutUI from "../LogoutUI";

const defaultMessage =
  "✅ Onboarding has been completed, but no active district is currently assigned to your account.Please contact your system administrator for further assistance.";

const AccessMessagePage = ({ msg = defaultMessage }) => {
  return (
    <Paper
      sx={{
        width: "50%",
        minHeight: "200px",
        transform: "translate(-50%, -50%)",
        top: "50%",
        left: "50%",
        position: "absolute",
        padding: 4,
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
      }}
      component={Stack}
      direction="column"
      elevation={12}
    >
      <Typography variant="h5" sx={{ textAlign: "center" }}>
        {msg}
      </Typography>

      {/* CognitoUI component Logout button */}
      <LogoutUI showName={true} />
    </Paper>
  );
};

export default AccessMessagePage;
